function verificaSiglaUnidade(unidade) {
    let sigla = unidade;
    switch(unidade.trim()) {
        case "5201183 Faculdade SENAI da Paraíba":
            sigla = "FACULDADE";
            break;
        case "1117489 Centro de Formação Profissional Professor Stenio Lopes":
            sigla = "SL";
            break;
        case "1117490 Centro de Inovação e Tecnologia Industrial - CITI":
            sigla = "CITI";
            break;
        case "1117488 Centro de Educação Profissional Odilon Ribeiro Coutinho":
            sigla = "ORC";
            break;
        case "1117487 Centro de Formação Prof. Eng. Jose William Lemos Leal":
            sigla = "JWLL";
            break;
        case "1117491 Centro de Tecnologia do Couro e do Calçado Albano Franco":
            sigla = "CTCC";
            break;
        case "5140965 Centro de Formação Profissional Miriam Benevides Gadelha":
            sigla = "MBG SOUSA";
            break;
        case "1169095 Centro de Ações Móveis - CAM":
            sigla = "CITI/CAM";
            break;
        case "5297028 Centro de Formação Profissional Robson Braga de Andrade":
            sigla = "RBA";
            break;
    }
    return sigla
}

function formataNumero(num) {
    return num.toLocaleString("pt-br");
}

export default { formataNumero, verificaSiglaUnidade }